import { NextResponse } from 'next/server'
import { query, uuid } from '@/lib/db'

export async function GET() {
  const shops = await query('SELECT * FROM shops ORDER BY name')
  return NextResponse.json(shops)
}

export async function POST(req: Request) {
  const { name } = await req.json()
  const id = uuid()
  await query('INSERT INTO shops (id, name) VALUES (?, ?)', [id, name])
  const shop = await query('SELECT * FROM shops WHERE id = ?', [id])
  return NextResponse.json(shop[0])
}
